{
  "address": {
    "streetAddress": "Adresse (numéro et rue)",
    "enterManually": "Saisir l’adresse manuellement",
    "useAutocomplete": "Utiliser la saisie automatique d’adresse",
    "missingNumber": "Ajoutez le numéro de rue pour compléter cette adresse.",
    "copyToReturn": "Utiliser également ces informations pour l’adresse de retour",
    "googleAttribution": "Google Maps"
  },
  "attachmentUpload": {
    "computerSubtitle": "Ajoutez un fichier depuis cet ordinateur.",
    "photoTitle": "Ajouter des photos",
    "documentTitle": "Ajouter des documents",
    "subtitle": "Ajoutez un fichier depuis cet ordinateur ou générez un QR code pour l'ajouter depuis un mobile.",
    "qrSubtitle": "Pour ajouter la pièce jointe, scannez le QRCode.",
    "fileLabel": "Ajouter votre pièce jointe",
    "mobile": "Via votre téléphone ou pad",
    "computer": "Via votre ordinateur",
    "maxFiles": "Jusqu'à {count} fichiers",
    "partial": "Certains fichiers n'ont pas pu être ajoutés. Seuls les fichiers en échec restent sélectionnés ; réessayez.",
    "fromComputer": "Depuis l'ordinateur",
    "viaMobile": "Via mobile",
    "loadFailed": "Impossible de charger le lien d’envoi mobile.",
    "retry": "Réessayer",
    "missing": "Le fichier n’a pas encore été envoyé.",
    "confirm": "Confirmer l’envoi"
  },
  "publicPage": {
    "loading": "Chargement…",
    "invalidTitle": "Lien expiré ou invalide",
    "invalidMessage": "Demandez un nouveau lien ou QR code depuis le dossier, ou contactez l’expéditeur.",
    "failedTitle": "Impossible de charger la page",
    "failedMessage": "La page n’a pas pu être chargée. Vérifiez votre connexion et réessayez.",
    "retry": "Réessayer"
  },
  "publicUpload": {
    "or": "ou",
    "browse": "parcourez vos fichiers",
    "maxSize": "Taille maximale {size} {unit}",
    "tooLarge": "Ce fichier dépasse la taille maximale autorisée.",
    "replacePhoto": "Remplacer la photo",
    "invalidFormat": "Ce format de fichier n'est pas accepté."
  },
  "notAuthorized": "Accès non autorisé",
  "noData": "Aucune donnée",
  "noValue": "-",
  "notProvided": "Non renseigné",
  "exportScheduled": "Export programmé. Vous recevrez le fichier par email.",
  "currency": {
    "euro": "€"
  },
  "units": {
    "kilogram": "kg",
    "wattHour": "Wh",
    "centimeter": "cm",
    "tonne": "t",
    "volt": "V",
    "ampereHour": "Ah",
    "byte": "o",
    "kilobyte": "Ko",
    "megabyte": "Mo"
  },
  "percent": "%",
  "tax": {
    "excluding": "HT"
  },
  "datePlaceholder": "JJ/MM/AAAA",
  "loading": "Chargement...",
  "buttons": {
    "confirm": "Confirmer",
    "retry": "Réessayer",
    "back": "Retour",
    "cancel": "Annuler",
    "validate": "Valider",
    "detail": "Détail",
    "update": "Modifier",
    "delete": "Supprimer",
    "add": "Ajouter",
    "remove": "Supprimer"
  },
  "yes": "Oui",
  "no": "Non",
  "filter": {
    "search": "Rechercher",
    "showFilters": "Afficher les filtres",
    "export": "Exporter",
    "clearFilters": "Supprimer les filtres"
  },
  "inputs": {
    "otherSelected": "+ {count} autre sélectionné",
    "othersSelected": "+ {count} autres sélectionnés"
  },
  "navigation": {
    "dashboard": "Accueil",
    "keyAccountProducts": "Parc produits",
    "repairFiles": "Dossiers de réparation",
    "users": "Utilisateurs",
    "transporters": "Transporteurs",
    "profile": "Profil",
    "environmentalPerformanceReport": "Analyse performance environnementale",
    "help": "Aide",
    "logout": "Déconnexion"
  }
}
